import { Action } from 'redux-actions';
import { all, put, select, takeEvery } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getRepairersByTypeAndSellerIdRequest } from '../../api/Repairer/getRepairersByTypeAndSellerIdQuery';

import { GetRepairerByTypeAndSellerIdPayload } from './actionCreators';
import * as types from './actionTypes';
import { formatRepairerTypeAndSellerIdIndexer } from './helpers';
import {
  selectGetRepairerByTypeAndSellerIdIsLoading,
  selectGetRepairerTypeAndBySellerIdWasLoaded,
} from './selectors';

function* getRepairersBySellerIdWorker({
  payload,
}: {
  payload: GetRepairerByTypeAndSellerIdPayload;
}): Generator {
  const { sellerId, repairerType } = payload;

  if (!sellerId) {
    return;
  }

  const isLoading = yield select(selectGetRepairerByTypeAndSellerIdIsLoading, {
    sellerId,
    repairerType,
  });
  const wasLoaded = yield select(selectGetRepairerTypeAndBySellerIdWasLoaded, {
    sellerId,
    repairerType,
  });

  if (isLoading || wasLoaded) {
    return;
  }

  yield executeSagaRequest(
    types.GET_REPAIRERS_BY_TYPE_AND_SELLER_ID,
    getRepairersByTypeAndSellerIdRequest({ sellerId, repairerType }),
    {
      sellerId,
      indexer: formatRepairerTypeAndSellerIdIndexer({ sellerId, repairerType }),
    },
  );

  yield put(
    types.GET_REPAIRERS_BY_TYPE_AND_SELLER_ID.end({ sellerId, repairerType }),
  );
}
function* getRepairersBySellerIdWatcher() {
  yield takeEvery<Action<GetRepairerByTypeAndSellerIdPayload>>(
    types.GET_REPAIRERS_BY_TYPE_AND_SELLER_ID.BASE,
    getRepairersBySellerIdWorker,
  );
}

export default function* repairerSaga(): Generator {
  try {
    yield all([getRepairersBySellerIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
